import styled from 'styled-components';
import { TextField, Button, Tabs, Tab, Dialog } from '@mui/material';
import { MINT_MIST } from '../../constants/brandSurfaces';

const blue = '#0d4efe';
const teal = '#01ebb2';
const ink = '#1a1a2e';
const muted = '#5a6478';
const line = 'rgba(26, 26, 46, 0.08)';

export const AccountPageWrapper = styled.div`
  .account-page {
    display: flex;
    flex-direction: column;
    padding-bottom: 48px;
  }

  .account-header {
    margin: 12px 0 20px;
    padding: 40px 44px;
    border-radius: 24px;
    background: ${MINT_MIST};
    border: 1px solid rgba(26, 26, 46, 0.06);
    text-align: left;

    @media (max-width: 900px) {
      padding: 30px 26px;
    }

    @media (max-width: 600px) {
      padding: 24px 16px;
      border-radius: 18px;
      margin-bottom: 14px;
    }
  }

  .header-eyebrow {
    margin: 0 0 8px;
    font-size: 0.95rem;
    font-weight: 700;
    color: ${blue};
  }

  .header-title {
    margin: 0 0 10px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 2.4rem;
    font-weight: 700;
    line-height: 1.15;
    letter-spacing: -0.02em;
    color: ${ink};

    @media (max-width: 900px) {
      font-size: 2rem;
    }

    @media (max-width: 600px) {
      font-size: 1.65rem;
    }
  }

  .header-subtitle {
    margin: 0;
    font-size: 1.05rem;
    line-height: 1.55;
    color: ${muted};
  }

  .main-content {
    flex: 1;
    width: 100%;
  }

  .tabs-container {
    background: #ffffff;
    border-radius: 20px;
    border: 1px solid ${line};
    box-shadow: 0 4px 16px rgba(26, 26, 46, 0.05);
    overflow: hidden;
    width: 100%;

    @media (max-width: 600px) {
      border-radius: 16px;
    }
  }

  .tab-content {
    padding: 28px 32px 32px;
    width: 100%;

    @media (max-width: 960px) {
      padding: 22px 20px;
    }

    @media (max-width: 600px) {
      padding: 18px 14px;
    }
  }

  .tab-title {
    margin: 0 0 20px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.4rem;
    font-weight: 700;
    letter-spacing: -0.01em;
    color: ${ink};

    @media (max-width: 600px) {
      font-size: 1.2rem;
      margin-bottom: 14px;
    }
  }

  .form-grid {
    margin-bottom: 24px;
    width: 100%;
  }

  .button-group {
    display: flex;
    gap: 16px;
    margin-top: 32px;
    flex-wrap: wrap;

    @media (max-width: 600px) {
      flex-direction: column;
      gap: 12px;
      margin-top: 24px;
    }
  }

  .accountFormActions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-top: 32px;
    flex-wrap: wrap;

    @media (max-width: 600px) {
      flex-direction: column;
      align-items: stretch;
      margin-top: 24px;
    }
  }

  .accountFormActionsStart {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
  }

  .danger-zone-section {
    margin-top: 24px;
    padding: 24px 28px;
    background: #ffffff;
    border: 1px solid ${line};
    border-radius: 20px;
    text-align: left;

    .MuiTypography-h6 {
      font-family: 'Plus Jakarta Sans', sans-serif;
      font-weight: 700;
      font-size: 1.1rem;
      color: ${ink};
    }

    @media (max-width: 960px) {
      margin-top: 32px;
      padding: 20px;
    }

    @media (max-width: 600px) {
      margin-top: 24px;
      padding: 16px;
    }
  }

  .saved-businesses-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 24px;
    margin-top: 24px;

    @media (max-width: 960px) {
      grid-template-columns: 1fr;
      gap: 16px;
      margin-top: 16px;
    }
  }

  .business-card-wrapper {
    border-radius: 16px;
    overflow: hidden;
    background-color: #ffffff;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    transition:
      transform 0.2s ease,
      box-shadow 0.2s ease;
    width: 100%;
    max-width: 100%;

    @media (max-width: 960px) {
      border-radius: 12px;
      max-width: 100%;
      overflow: visible;
    }

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    }
  }

  .recommendation-history-card {
    width: 100%;
    border-radius: 16px;
    border: 1px solid ${line};
    background: #ffffff;
    box-shadow: 0 2px 10px rgba(26, 26, 46, 0.04);
    padding: 16px 16px 14px;
    cursor: pointer;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;

    &:hover {
      border-color: rgba(13, 78, 254, 0.3);
      box-shadow: 0 10px 24px rgba(13, 78, 254, 0.1);
    }
  }

  .recommendation-history-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 6px;
  }

  .recommendation-history-title {
    font-weight: 700;
    color: #1a1f36;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .recommendation-history-meta {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
  }

  .recommendation-history-count {
    display: inline-flex;
    align-items: center;
    border-radius: 999px;
    padding: 2px 10px;
    font-size: 0.78rem;
    font-weight: 700;
    color: ${ink};
    background-color: rgba(1, 235, 178, 0.16);
    border: none;
    white-space: nowrap;
  }

  .recommendation-history-request {
    margin-top: 6px;
    border-top: 1px solid ${line};
    padding-top: 8px;
    color: ${muted};
    line-height: 1.45;
  }

  .recommendation-history-request strong {
    color: #0d4efe;
  }

  .wizard-request-card {
    width: 100%;
    border-radius: 16px;
    border: 1px solid ${line};
    background: #ffffff;
    box-shadow: 0 2px 10px rgba(26, 26, 46, 0.04);
    padding: 16px 16px 14px;
    cursor: pointer;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;

    &:hover {
      border-color: rgba(13, 78, 254, 0.3);
      box-shadow: 0 10px 24px rgba(13, 78, 254, 0.1);
    }
  }

  .wizard-request-header {
    display: flex;
    align-items: flex-start;
    gap: 10px;
  }

  .wizard-request-title-wrap {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }

  .wizard-request-created {
    margin-top: 2px;
    color: #1a1f36;
    font-weight: 700;
    line-height: 1.3;
  }

  .wizard-request-meta-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
    flex-wrap: wrap;
  }

  .wizard-request-meta {
    display: inline-flex;
    align-items: center;
    border-radius: 999px;
    padding: 2px 10px;
    font-size: 0.78rem;
    font-weight: 700;
    color: ${ink};
    background-color: rgba(1, 235, 178, 0.16);
    border: none;
    white-space: nowrap;
  }

  .wizard-request-problem {
    margin-top: 8px;
    border-top: 1px solid ${line};
    padding-top: 8px;
    color: ${muted};
    line-height: 1.45;
  }

  .wizard-request-actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid ${line};

    .MuiButton-root {
      width: 100%;
      justify-content: center;
    }

    @media (max-width: 600px) {
      grid-template-columns: 1fr;
    }
  }

  .service-requests-subtabs-wrap {
    margin-bottom: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }

  .custom-service-request-card {
    width: 100%;
    border-radius: 16px;
    border: 1px solid ${line};
    background: #ffffff;
    box-shadow: 0 2px 10px rgba(26, 26, 46, 0.04);
    padding: 14px 14px 12px;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
      border-color: rgba(13, 78, 254, 0.2);
    }
  }

  .custom-service-request-business {
    margin-top: 8px;
    font-size: 0.875rem;
    font-weight: 600;
    color: #0d4efe;
  }

  .custom-service-request-hint {
    margin-top: 8px;
    font-size: 0.78rem;
    color: #8a94a6;
    font-style: italic;
  }

  .empty-state {
    text-align: center;
    padding: 32px 24px;
    background: ${MINT_MIST};
    border: 1px dashed rgba(26, 26, 46, 0.14);
    border-radius: 16px;
    margin-top: 8px;
  }

  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
  }

  .error-container {
    padding: 24px;
    margin: 24px;
  }
`;

export const StyledTabs = styled(Tabs)`
  border-bottom: 1px solid ${line};

  .MuiTab-root {
    font-family: inherit;
    font-weight: 600;
    font-size: 1rem;
    text-transform: none;
    min-height: 60px;
    color: ${muted};

    &.Mui-selected {
      color: ${ink};
    }

    @media (max-width: 960px) {
      font-size: 0.9rem;
      min-height: 56px;
      padding: 12px 16px;
      min-width: 120px;
    }

    @media (max-width: 600px) {
      font-size: 0.85rem;
      min-height: 48px;
      padding: 10px 12px;
      min-width: 100px;
    }
  }

  .MuiTabs-indicator {
    background: linear-gradient(90deg, ${teal} 0%, ${blue} 100%);
    height: 3px;
    border-radius: 3px 3px 0 0;
  }

  @media (max-width: 960px) {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    
    &::-webkit-scrollbar {
      display: none;
    }
    
    scrollbar-width: none;
  }
`;

export const StyledTab = styled(Tab)`
  font-weight: 600;
  font-size: 1rem;
  text-transform: none;
  min-height: 60px;

  &.Mui-selected {
    color: ${ink};
  }

  @media (max-width: 960px) {
    font-size: 0.9rem;
    min-height: 56px;
    padding: 12px 16px;
    min-width: 120px;
  }

  @media (max-width: 600px) {
    font-size: 0.85rem;
    min-height: 48px;
    padding: 10px 12px;
    min-width: 100px;
  }
`;

/** Nested tabs inside Service requests */
export const ServiceRequestsSubTabs = styled(Tabs)`
  min-height: 44px;

  .MuiTab-root {
    font-weight: 600;
    font-size: 0.9rem;
    text-transform: none;
    min-height: 44px;
    padding: 8px 16px;
    color: #5a6478;

    &.Mui-selected {
      color: ${ink};
    }
  }

  .MuiTabs-indicator {
    background: linear-gradient(90deg, ${teal} 0%, ${blue} 100%);
    height: 2px;
  }
`;

export const ServiceRequestsSubTab = styled(Tab)`
  font-weight: 600;
  font-size: 0.9rem;
  text-transform: none;
  min-height: 44px;
`;

export const StyledTextField = styled(TextField)`
  .MuiOutlinedInput-root {
    border-radius: 10px;
    background: #f7fafc;

    .MuiOutlinedInput-notchedOutline {
      border: 1.5px solid rgba(26, 26, 46, 0.12);
    }

    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: rgba(26, 26, 46, 0.24);
    }

    &.Mui-focused {
      background: #ffffff;
    }

    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: ${blue};
    }

    &.Mui-disabled {
      background: rgba(26, 26, 46, 0.04);
    }
  }

  .MuiInputLabel-root {
    font-weight: 600;
    color: ${muted};

    &.Mui-focused {
      color: ${blue};
    }
  }
`;

export const PrimaryButton = styled(Button)`
  && {
    background: linear-gradient(90deg, ${teal} 0%, ${blue} 100%);
    color: #ffffff;
    font-family: inherit;
    font-weight: 700;
    padding: 11px 24px;
    border-radius: 10px;
    text-transform: none;
    font-size: 1rem;
    box-shadow: 0 4px 14px rgba(13, 78, 254, 0.35);
  }

  &&:hover {
    filter: brightness(1.05);
    box-shadow: 0 6px 18px rgba(13, 78, 254, 0.4);
  }
`;

export const SecondaryButton = styled(Button)`
  && {
    border: 1.5px solid ${ink};
    color: ${ink};
    background: #ffffff;
    font-family: inherit;
    font-weight: 700;
    padding: 10px 22px;
    border-radius: 10px;
    text-transform: none;
    font-size: 1rem;
  }

  &&:hover {
    border-color: ${blue};
    color: ${blue};
    background: #ffffff;
  }
`;

/** Compact CTA inside service-request cards. */
export const ServiceRequestPrimaryButton = styled(Button)`
  font-family: 'DM Sans', 'Segoe UI', sans-serif;
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1.25;
  text-transform: none;
  border-radius: 10px;
  padding: 10px 18px;
  min-height: 42px;
  box-shadow: 0 4px 14px rgba(13, 78, 254, 0.25);
  background: linear-gradient(90deg, ${teal} 0%, ${blue} 100%);
  color: #fff;

  .MuiButton-startIcon {
    margin-right: 8px;
    margin-left: -2px;
  }

  &:hover {
    background: linear-gradient(90deg, ${teal} 0%, ${blue} 100%);
    filter: brightness(1.05);
    box-shadow: 0 6px 18px rgba(13, 78, 254, 0.35);
  }

  &.Mui-disabled {
    background: rgba(0, 0, 0, 0.08);
    color: rgba(0, 0, 0, 0.38);
    box-shadow: none;
    transform: none;
  }
`;

export const ServiceRequestSecondaryButton = styled(Button)`
  font-family: 'DM Sans', 'Segoe UI', sans-serif;
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1.25;
  text-transform: none;
  border-radius: 10px;
  padding: 10px 18px;
  min-height: 42px;
  border-width: 1.5px;
  border-style: solid;
  border-color: ${ink};
  color: ${ink};
  background-color: #fff;

  .MuiButton-startIcon {
    margin-right: 8px;
    margin-left: -2px;
  }

  &:hover {
    background-color: #fff;
    border-color: ${blue};
    color: ${blue};
  }

  &.Mui-disabled {
    border-color: rgba(0, 0, 0, 0.12);
    color: rgba(0, 0, 0, 0.26);
    background-color: #fafafa;
    box-shadow: none;
    transform: none;
  }
`;

export const DangerButton = styled(Button)`
  && {
    background: #ffffff;
    color: #c62828;
    border: 1.5px solid rgba(198, 40, 40, 0.5);
    font-family: inherit;
    font-weight: 700;
    padding: 10px 22px;
    border-radius: 10px;
    text-transform: none;
    font-size: 1rem;
  }

  &&:hover {
    background: rgba(198, 40, 40, 0.06);
    border-color: #c62828;
  }
`;

export const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 16px;
    padding: 8px;
  }

  .dialog-title {
    font-weight: 700;
    color: ${ink};
    font-size: 1.25rem;
    padding: 24px 24px 0;
  }

  .dialog-content {
    padding: 24px;
    color: #666;
    line-height: 1.5;
  }

  .dialog-actions {
    padding: 16px 24px 24px;
    display: flex;
    gap: 12px;
    justify-content: flex-end;
  }
`;

/** Delete-account confirmation: strong warning chrome (amber band, warm panel). */
export const DeleteAccountWarningDialog = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 14px;
    padding: 0;
    overflow: hidden;
    border: 1px solid rgba(217, 119, 6, 0.4);
    box-shadow:
      0 4px 28px rgba(245, 158, 11, 0.22),
      0 16px 48px rgba(0, 0, 0, 0.1);
  }

  .deleteWarnHeader {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    padding: 20px 24px 18px;
    background: linear-gradient(
      135deg,
      rgba(251, 191, 36, 0.35) 0%,
      rgba(245, 158, 11, 0.18) 55%,
      rgba(254, 243, 199, 0.45) 100%
    );
    border-bottom: 1px solid rgba(217, 119, 6, 0.28);
  }

  .deleteWarnTitle {
    font-weight: 800;
    font-size: 1.25rem;
    color: #92400e;
    line-height: 1.25;
    letter-spacing: -0.02em;
  }

  .deleteWarnSubtitle {
    margin-top: 8px;
    font-size: 0.9rem;
    font-weight: 600;
    color: #b45309;
    line-height: 1.35;
  }

  .deleteWarnBody {
    padding: 20px 24px;
    background: linear-gradient(180deg, #fffbeb 0%, #ffffff 70%);
  }

  .dialog-actions {
    padding: 16px 24px 22px;
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    flex-wrap: wrap;
    background: linear-gradient(180deg, rgba(255, 251, 235, 0.85) 0%, #fafafa 100%);
    border-top: 1px solid rgba(217, 119, 6, 0.18);
  }
`;
